module.exports = __webpack_public_path__ + "static/media/AshevilleHempFarms2newstorefrontdowntownAsheville2020Watergildedandhandlettered.7c037023.webp";